import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

import { ModalComponent, ModalTemplate } from "../reusableComponent";
import { GalleryTemplate } from "./teamGalery";

import rahul from "../../assets/team/rahuk_agarwal.jpg";
import ankit from "../../assets/team/ankit_anand.jpg";
import arushi from "../../assets/team/Arushi_Gupta_.jpeg";
import shreya from "../../assets/team/shreya_chaudhary.jpg";
import rohit from "../../assets/team/rohit_dua.jpeg";
import aanchal from "../../assets/team/aanchal_singh.jpg";
import yashita from "../../assets/team/yashita_jhurani.jpg";
import jyotika from "../../assets/team/Jyotika_Singh.jpg";
import prabhat from "../../assets/team/prabhat.jpg";
import diksha from "../../assets/team/diksha.jpg";
import sonali from "../../assets/team/sonali_chakravorty.jpeg";
import sidharth from "../../assets/team/sidharth_yadav.jpeg";
import priyanshi from "../../assets/team/priyanshi_arora.jpeg";
import {
  getDpiit,
  getPmg,
  getHeading,
  getSection,
  getUpdate
} from "../../actions/pmgTeam.action";
// import { getAbsoluteValueForTuple } from "html2canvas/dist/types/css/types/length-percentage";

const DPIIT = [
  {
    name: "Sumita Dawra",
    designation: "Special Secretary, DPIIT",
    tel: "011 23038927",
    email: "dawras[at]ias[dot]nic[dot]in",
    address: "Vanijya Bhawan, New Delhi"
  }
];

const PMG_TEAM = [
  {
    name: "Rahul Agarwal",
    designation: "Vice-President",
    tel: "+91 9205192106",
    email: "rahul[dot]agarwal[at]investindia[dot]org[dot]in",
    address: "Vigyan Bhawan Annexe, New Delhi",
    src: rahul
  },
  {
    name: "Ankit Anand",
    designation: "Assistant Vice President",
    tel: "+91 9205618744",
    email: "ankit[dot]anand[at]investindia[dot]org[dot]in",
    address: "Vigyan Bhawan Annexe, New Delhi",
    src: ankit
  },
  {
    name: "Yashita Jhurani",
    designation: "Senior Manager",
    tel: "+91 9205057443",
    email: "yashita[dot]jhurani[at]investindia[dot]org[dot]in",
    address: "Vigyan Bhawan Annexe, New Delhi",
    src: yashita
  },
  {
    name: "Shreya Chaudhary",
    designation: "Manager",
    tel: "+91 9205090054",
    email: "shreya[dot]chaudhary[at]investindia[dot]org[dot]in",
    address: "Vigyan Bhawan Annexe, New Delhi",
    src: shreya
  },
  {
    name: "Rohit Dua",
    designation: "Senior Manager",
    tel: "+91 9923478514",
    email: "rohit[dot]dua[at]investindia[dot]org[dot]in",
    address: "Vigyan Bhawan Annexe, New Delhi",
    src: rohit
  },
  {
    name: "Arushi Gupta",
    designation: "Manager",
    tel: "+91 9205500196",
    email: "arushi[dot]gupta2[at]investindia[dot]org[dot]in",
    address: "Vigyan Bhawan Annexe, New Delhi",
    src: arushi
  },
  {
    name: "Aanchal Singh",
    designation: "Assistant Manager",
    tel: "+91 9971948555",
    email: "aanchal[dot]singh[at]investindia[dot]org[dot]in",
    address: "Vigyan Bhawan Annexe, New Delhi",
    src: aanchal
  },
  {
    name: "Jyotika Singh",
    designation: "Associate",
    tel: "+91 9205008482",
    email: "jyotika[dot]singh[at]investindia[dot]org[dot]in",
    address: "Vigyan Bhawan Annexe, New Delhi",
    src: jyotika
  },
  {
    name: "Prabhat Singh",
    designation: "Consultant",
    tel: "+91 9560955882",
    email: "prabhat[dot]singh[at]investindia[dot]org[dot]in",
    address: "Vigyan Bhawan Annexe, New Delhi",
    src: prabhat
  },
  {
    name: "Diksha Bhanot",
    designation: "Associate",
    tel: "+91 9205019631",
    email: "diksha[dot]bhanot[at]investindia[dot]org[dot]in",
    address: "Vigyan Bhawan Annexe, New Delhi",
    src: diksha
  },
  {
    name: "Sonali Chakravorty",
    designation: "Assistant Manager",
    tel: "9205694281",
    email: "sonali[dot]chakravorty[at]investindia[dot]org[dot]in",
    address: "Vigyan Bhawan Annexe, New Delhi",
    src: sonali
  },
  {
    name: "Sidharth Yadav",
    designation: "Consultant",
    tel: "9821767302",
    email: "sidharth[dot]yadav[at]investindia[dot]org[dot]in",
    address: "Vigyan Bhawan Annexe, New Delhi",
    src: sidharth
  },
  {
    name: "Priyanshi",
    designation: "Associate",
    tel: "9205932220",
    email: "priyanshi[dot]arora[at]investindia[dot]org[dot]in",
    address: "Vigyan Bhawan Annexe, New Delhi",
    src: priyanshi
  }
];

const SECTION_OFFICIALS = [
  {
    name: "Vivek Lakhotra",
    designation: "Co-ordinator",
    tel: "9582859274",
    email: "vivek[dot]cci[at]nic[dot]in",
    address: "Udyog Bhawan, New Delhi"
  },
  {
    name: "Vipin Negi",
    designation: "Co-ordinator",
    tel: "8595846823",
    email: "vipin[dot]cabsec[at]nic[dot]in",
    address: "Udyog Bhawan, New Delhi"
  },
  {
    name: "Himanshu Chhabra",
    designation: "Co-ordinator",
    tel: "9310572747",
    email: "himanshu[dot]chhabra[at]investindia[dot]org[dot]in",
    address: "Udyog Bhawan, New Delhi"
  },
  {
    name: "Varun Dhawan",
    designation: "Co-ordinator",
    tel: "9758207256",
    email: "varun[dot]dhawan[at]gov[dot]in",
    address: "Udyog Bhawan, New Delhi"
  }
];

export default function PmgTeamModal(props) {
  const { onClose, className } = props;
  const [pmgInvestData, setPmgInvestData] = useState([]);
  const [dpiitData, setDpiitData] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [headerData, setHeaderData] = useState([]);

  const getInvestiListingData = async () => {
    try {
      const pmgData = await getPmg();
      setPmgInvestData(pmgData.data);
    } catch (error) {
      console.error("Error fetching PMG data:", error);
    }
  };
  console.log(pmgInvestData, "pmgInvestData");

  const getDpiitListingData = async () => {
    try {
      const dpData = await getDpiit();
      setDpiitData(dpData.data);
    } catch (error) {
      console.error("Error fetching DP data:", error);
    }
  };

  const getSectionListingData = async () => {
    try {
      const sectionData = await getSection();
      setSectionData(sectionData.data);
    } catch (error) {
      console.error("Error fetching Section data:", error);
    }
  };

  const getHeadingListingData = async () => {
    try {
      const headerDetails = await getHeading();
      setHeaderData(headerDetails.data.dropDown);
    } catch (error) {
      console.error("Error fetching Updated data:", error);
    }
  };

  useEffect(() => {
    getInvestiListingData();
    getDpiitListingData();
    getSectionListingData();
    getHeadingListingData();
  }, []);

  return (
    <ModalComponent
      containerClass={`team-gallery-container ${className}`}
      centered={true}
      template={
        <ModalTemplate
          footerDisplay={false}
          headerTitle="Meet Our Team"
          bodyTemplate={
            <div id="team-sections-container">
              <div className="team-sections">
                {headerData !== undefined && headerData.length > 0 && (
                  <h5 className="heading">{headerData[0].title}</h5>
                )}
                <GalleryTemplate
                  containerClass="team-gallery"
                  options={dpiitData}
                  // dpiitHeading=", DPIIT"
                />
              </div>
              <div className="team-sections">
                {headerData !== undefined && headerData.length > 0 && (
                  <h5 className="heading">{headerData[1].title}</h5>
                )}
                {console.log("pmgInvestData", pmgInvestData)}
                <GalleryTemplate
                  containerClass="team-gallery"
                  options={pmgInvestData}
                />
              </div>
              <div className="team-sections">
                {headerData !== undefined && headerData.length > 0 && (
                  <h5 className="heading">{headerData[2].title}</h5>
                )}
                <GalleryTemplate
                  containerClass="team-gallery"
                  options={sectionData}
                />
              </div>
            </div>
          }
        />
      }
      onClose={onClose}
    />
  );
}
